import React, { useState, useEffect, forwardRef } from "react";
import DatePicker from "react-datepicker";

import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import Button from "react-bootstrap/Button";

import "swiper/swiper.min.css";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import { motion, AnimatePresence } from "framer-motion";

import {
  search_contacts,
  getAvailableTimeSlots,
  createCalendarEvent,
  getUsers
} from "../constants/api-methods";

import { ModalContext } from "./Modal/modalContext";
import SlideButton from "./SlideButton";
import Loader from "./Loader";
import BookDatePopup from "./BookDatePopup";
import EmailInputPopup from "./EmailInputPopup";
import PayPalPopup from "./PayPalPopup";

const myNewDate = (date) => {
  let newDate = new Date(date);
  if (!isNaN(newDate)) return newDate;
  return new Date(date.replace(" ", "T"));
};

const convertTimeInLocalToCST = require("../constants/helpers/getNashvilleTime");

const times = [1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6];

const HOURLY_RATES = { production: 75, mix: 50 };

const convertToProperTime = (timeIn) => {
  const dateObj = myNewDate(timeIn);
  let amOrPm = "AM";

  const cst = convertTimeInLocalToCST(timeIn);

  const tzo = dateObj.getTimezoneOffset();
  dateObj.setHours(dateObj.getHours() - cst.offset);
  let hours = dateObj.getHours();
  hours = hours < 0 ? hours + 24 : hours;
  if (hours >= 12) {
    hours = hours > 12 ? hours - 12 : hours;
    amOrPm = "PM";
  }

  const minutes =
    dateObj.getMinutes() >= 10 ? dateObj.getMinutes() : "0" + dateObj.getMinutes();

  return `${hours}:${minutes} ${amOrPm}`;
};

export const MainPage = () => {
  let { handleModal, paymentConfirmed, setPaymentConfirmed } =
    React.useContext(ModalContext);

  const [contact, setContact] = useState(null);
  const [users, setUsers] = useState([]);

  const [availableTimeSlots, setAvailableTimeSlots] = useState(null);

  const [producerName, setProducerName] = useState(null);
  const [producerId, setProducerId] = useState(null);
  const [duration, setDuration] = useState(null);
  const [date, setDate] = useState(new Date());
  const [swiper, setSwiper] = useState(null);
  const [swiperStep, setSwiperStep] = useState(1);
  const [isFetching, setIsFetching] = useState(false);
  const [timeSlotState, setTimeSlotState] = useState(null);
  const [sessionType, setSessionType] = useState(null);
  const [a_ats, setA_ats] = useState();
  const [b_ats, setB_ats] = useState();

  useEffect(() => {
    // handleModal();
    getUsers(setUsers);

    // setPaymentConfirmed(() => {
    //   console.log("hi");
    // });
  }, []);

  useEffect(() => {
    if (contact) {
      // handleModal();
    }
  }, [contact]);

  useEffect(() => {
    console.log(users);
  }, [users]);

  useEffect(() => {
    if (timeSlotState) {
      setTimeSlotState(null);
    }
  }, [producerName, duration, sessionType]);

  const producerItems = [];
  const timeItems = [];
  const sessionTypes = [];

  const DateInput = forwardRef(({ value, onClick }, ref) => (
    <Button
      variant="outline-success"
      id="button"
      title={date ? date : "Select Date"}
      size="sm"
      onClick={onClick}
      ref={ref}
    >
      {value}
    </Button>
  ));

  for (let i = 0; i < users.length; i++) {
    producerItems.push(
      <Dropdown.Item
        onMouseUp={() => {
          setProducerName(users[i].full_name);
          setProducerId(users[i].id);
        }}
        active={producerId === users[i].id}
      >
        {users[i].full_name}
      </Dropdown.Item>
    );
  }

  for (let i = 0; i < times.length; i++) {
    timeItems.push(
      <Dropdown.Item
        onMouseUp={() => {
          setDuration(times[i]);
        }}
        active={duration === times[i]}
      >
        {times[i]} hrs
      </Dropdown.Item>
    );
  }

  sessionTypes.push(
    <Dropdown.Item
      onMouseUp={() => {
        setSessionType("production");
      }}
      active={sessionType === "production"}
    >
      Production Session
    </Dropdown.Item>
  );

  sessionTypes.push(
    <Dropdown.Item
      onMouseUp={() => {
        setSessionType("mix");
      }}
      active={sessionType === "mix"}
    >
      Mix Session
    </Dropdown.Item>
  );

  useEffect(() => {
    let aTimes = [];
    let bTimes = [];
    if (availableTimeSlots) {
      for (let i = 0; i < availableTimeSlots.length; i++) {
        const start = convertToProperTime(availableTimeSlots[i].start);
        const end = convertToProperTime(availableTimeSlots[i].end);

        //console.log(1, start);
        //console.log(2, availableTimeSlots[i].start);
        const eventInfo = {
          // name: "TEST",
          startDatetime: availableTimeSlots[i].start,
          endDatetime: availableTimeSlots[i].end,
          studioId: availableTimeSlots[i].id,
          userId: producerId,
          contactId: contact.contact_id
        };

        const timeSlot = (
          <button
            style={{
              background:
                timeSlotState === start + availableTimeSlots[i].name
                  ? "#ebff06"
                  : "",
              border:
                timeSlotState === start + availableTimeSlots[i].name
                  ? "1px solid #333333"
                  : "",
              marginLeft:
                timeSlotState === start + availableTimeSlots[i].name ? "0px" : ""
            }}
            onClick={() => {
              handleModal(
                <PayPalPopup
                  date={date}
                  start={start}
                  end={end}
                  producer={producerName}
                  eventInfo={eventInfo}
                  bookingInfo={{
                    contact_id: contact.contact_id,
                    user_id: producerId,
                    studio_id: eventInfo.studioId,
                    start: eventInfo.startDatetime,
                    end: eventInfo.endDatetime,
                    duration,
                    hourly_price: HOURLY_RATES[sessionType],
                    session_type: sessionType,
                    producer_name: producerName,
                    artist_name: contact.name
                  }}
                />
              );
              setTimeSlotState(start + availableTimeSlots[i].name);
            }}
          >
            <div className="slot-text">
              <div>{start}</div>
            </div>
          </button>
        );

        if (availableTimeSlots[i].name === "Studio A") {
          aTimes.push(timeSlot);
        } else {
          bTimes.push(timeSlot);
        }
      }
    }
    //console.log(aTimes);
    //console.log(bTimes);
    setA_ats(aTimes);
    setB_ats(bTimes);
  }, [availableTimeSlots]);
  // if (!contact) {
  //   return
  // }

  const animateOut = {
    hidden: {
      y: "0vh",
      opacity: 1
    },
    visible: {
      y: "0",
      opacity: 1,
      transition: {
        duration: 0.1,
        type: "spring",
        damping: 25,
        stiffness: 500
      }
    },
    exit: {
      x: "-100vw",
      opacity: 0,
      rotate: 0,
      transition: {
        duration: 0.4
      }
    }
  };

  return (
    <>
      <AnimatePresence>
        {!contact && (
          <motion.div
            variants={animateOut}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <EmailInputPopup contact={contact} setContact={setContact} />
          </motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {contact && (
          <motion.div
            initial={{
              opacity: 0,
              x: "100vw",
              transition: {
                delay: 0.2,
                duration: 0.4
              }
            }}
            animate={{
              opacity: 1,
              x: "0vw",
              transition: {
                delay: 0.1,
                duration: 0.6
              }
            }}
            exit={{ opacity: 0 }}
          >
            <div className="main">
              <Swiper
                spaceBetween={50}
                style={{ width: "100vw" }}
                slidesPerView={1}
                allowTouchMove={false}
                onSwiper={(swiperInstance) => {
                  setSwiper(swiperInstance);
                }}
                onSlideChange={(swiperInstance) => {
                  setSwiperStep(swiperInstance.activeIndex + 1);
                  console.log(swiperStep);
                }}
              >
                <div className="slideStep-img --absolute">
                  <div className="slideStep-imgInner">
                    <img
                      src="/imgs/background-gradient.jpg"
                      alt=""
                      className="slideStep-img --absolute"
                    />
                    <img className="--logo" src="/imgs/altru-logo.png" alt="" />
                    <h1 className="email-title">
                      Schedule <br />
                      <b>STUDIO SESSION</b>
                    </h1>
                    <div className="rule"></div>
                    <div className="slideStep-step">
                      <div
                        className="slideStep-stepCircle"
                        style={{
                          background: swiperStep > 0 ? "#F3F3F3" : ""
                        }}
                      ></div>{" "}
                      Select Producer
                    </div>
                    <div className="slideStep-step">
                      <div
                        className="slideStep-stepCircle"
                        style={{
                          background: swiperStep > 1 ? "#F3F3F3" : ""
                        }}
                      ></div>
                      Select Date
                    </div>
                    <div className="slideStep-step">
                      <div
                        className="slideStep-stepCircle"
                        style={{
                          background: swiperStep > 2 ? "#F3F3F3" : ""
                        }}
                      ></div>{" "}
                      Payment
                    </div>
                  </div>
                </div>
                <SwiperSlide>
                  <div className="slideStep-inner">
                    <img
                      src="/imgs/background-gradient.jpg"
                      alt=""
                      className="slideStep-img"
                    />

                    <div className="slideStep-content">
                      <h1 className="email-title">
                        Select <br />
                        <b>Your Producer</b>
                        <svg
                          className="titleImg"
                          width="372"
                          height="294"
                          viewBox="0 0 372 294"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M317.924 64.51C321.564 69.6959 321.766 77.1579 318.651 86.4596C315.543 95.7379 309.196 106.639 300.092 118.469C281.89 142.119 252.81 169.294 217.159 194.356C181.508 219.419 146.1 237.578 117.695 246.693C103.487 251.252 91.0861 253.53 81.3102 253.308C71.5096 253.087 64.5637 250.365 60.9234 245.179C57.2831 239.993 57.0806 232.531 60.1961 223.23C63.3037 213.951 69.6506 203.05 78.7554 191.22C96.9573 167.57 126.037 140.396 161.688 115.333C197.339 90.2706 232.747 72.1113 261.152 62.9967C275.36 58.4375 287.761 56.1596 297.537 56.3809C307.337 56.6027 314.283 59.3241 317.924 64.51Z"
                            stroke="#D8E75F"
                            stroke-width="2"
                          />
                          <path
                            d="M310.798 48.5681C314.439 53.754 314.641 61.216 311.526 70.5177C308.418 79.796 302.071 90.6974 292.967 102.527C274.765 126.177 245.685 153.352 210.034 178.414C174.383 203.477 138.975 221.636 110.57 230.751C96.3615 235.31 83.9611 237.588 74.1852 237.366C64.3846 237.145 57.4387 234.423 53.7984 229.237C50.1581 224.051 49.9556 216.589 53.0711 207.288C56.1787 198.01 62.5256 187.108 71.6304 175.278C89.8323 151.628 118.912 124.454 154.563 99.3912C190.214 74.3287 225.622 56.1694 254.027 47.0548C268.235 42.4956 280.636 40.2177 290.412 40.439C300.212 40.6608 307.158 43.3823 310.798 48.5681Z"
                            stroke="#D8E75F"
                            stroke-width="2"
                          />
                        </svg>
                      </h1>

                      <div className="slideStep-dropDowns --noBottom">
                        <div className="dropdown-ctn">
                          <DropdownButton
                            className="slideStep-dropDown"
                            variant="outline-success"
                            id="dropdown-basic-button"
                            title={producerName ? producerName : "Producer"}
                            size="sm"
                          >
                            {producerItems}
                          </DropdownButton>
                        </div>
                        <div className="dropdown-ctn">
                          <DropdownButton
                            className="slideStep-dropDown"
                            variant="outline-success"
                            id="dropdown-basic-button"
                            title={duration ? duration + " hrs" : "Duration"}
                            size="sm"
                          >
                            {timeItems}
                          </DropdownButton>
                        </div>
                      </div>
                      <div className="slideStep-dropDowns --noTop">
                        <div className="dropdown-ctn --full">
                          <DropdownButton
                            className="slideStep-dropDown"
                            variant="outline-success"
                            id="dropdown-basic-button"
                            title={
                              sessionType ? sessionType + " session" : "Session Type"
                            }
                            size="sm"
                          >
                            {sessionTypes}
                          </DropdownButton>
                        </div>
                      </div>

                      <div className="slideStep-buttonCon">
                        {/* <SlideButton
                          click={() => {
                            swiper.slidePrev();
                          }}
                          back={true}
                        >
                          Back
                        </SlideButton> */}
                        <div></div>
                        <SlideButton
                          click={() => {
                            console.log("next");
                            swiper.slideNext();
                            setIsFetching(true);
                            getAvailableTimeSlots(
                              producerId,
                              duration,
                              date,
                              setAvailableTimeSlots,
                              () => {
                                setIsFetching(false);
                              }
                            );
                          }}
                          enabled={producerName && duration}
                        >
                          Next
                        </SlideButton>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="slideStep-inner">
                    <img
                      src="/imgs/background-gradient.jpg"
                      alt=""
                      className="slideStep-img"
                    />

                    <div className="slideStep-content">
                      <h1 className="email-title">
                        Select Time
                        <br />
                        <b>& DATE</b>
                        <svg
                          className="titleImg"
                          width="372"
                          height="294"
                          viewBox="0 0 372 294"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M317.924 64.51C321.564 69.6959 321.766 77.1579 318.651 86.4596C315.543 95.7379 309.196 106.639 300.092 118.469C281.89 142.119 252.81 169.294 217.159 194.356C181.508 219.419 146.1 237.578 117.695 246.693C103.487 251.252 91.0861 253.53 81.3102 253.308C71.5096 253.087 64.5637 250.365 60.9234 245.179C57.2831 239.993 57.0806 232.531 60.1961 223.23C63.3037 213.951 69.6506 203.05 78.7554 191.22C96.9573 167.57 126.037 140.396 161.688 115.333C197.339 90.2706 232.747 72.1113 261.152 62.9967C275.36 58.4375 287.761 56.1596 297.537 56.3809C307.337 56.6027 314.283 59.3241 317.924 64.51Z"
                            stroke="#D8E75F"
                            stroke-width="2"
                          />
                          <path
                            d="M310.798 48.5681C314.439 53.754 314.641 61.216 311.526 70.5177C308.418 79.796 302.071 90.6974 292.967 102.527C274.765 126.177 245.685 153.352 210.034 178.414C174.383 203.477 138.975 221.636 110.57 230.751C96.3615 235.31 83.9611 237.588 74.1852 237.366C64.3846 237.145 57.4387 234.423 53.7984 229.237C50.1581 224.051 49.9556 216.589 53.0711 207.288C56.1787 198.01 62.5256 187.108 71.6304 175.278C89.8323 151.628 118.912 124.454 154.563 99.3912C190.214 74.3287 225.622 56.1694 254.027 47.0548C268.235 42.4956 280.636 40.2177 290.412 40.439C300.212 40.6608 307.158 43.3823 310.798 48.5681Z"
                            stroke="#D8E75F"
                            stroke-width="2"
                          />
                        </svg>
                      </h1>
                      <div className="slideStep-dropDowns --date">
                        <div className="selection-ctn">
                          <DatePicker
                            selected={date}
                            minDate={new Date()}
                            onChange={(date) => {
                              setTimeSlotState(null);
                              setDate(date);
                              setIsFetching(true);
                              setTimeout(() => {
                                getAvailableTimeSlots(
                                  producerId,
                                  duration,
                                  date,
                                  setAvailableTimeSlots,
                                  () => {
                                    setIsFetching(false);
                                  }
                                );
                              }, 100);
                            }}
                            // selectsRange
                            inline
                            // customInput={<DateInput />}
                          />
                          {/* <DateInput /> */}

                          {/* <div className="button-ctn">
                            <button
                              onClick={() => {
                                getAvailableTimeSlots(
                                  producerId,
                                  duration,
                                  date,
                                  setAvailableTimeSlots
                                );
                              }}
                              disabled={!producerId || !duration}
                            >
                              GO!
                            </button>
                          </div> */}
                        </div>

                        <div className="time-slots-ctn">
                          <div className="times-title">Time Slot</div>
                          {/* <div className="times-notice">*All time in CST</div> */}
                          <div className="scroll-con">
                            {availableTimeSlots && !isFetching ? (
                              <>
                                {/* {(a || b) && (
                              )} */}
                                {a_ats && (
                                  <div className="studio">
                                    <div className="times-studioName">
                                      Studio A
                                      {/* <div className="times-notice">
                                      *All time in CST
                                    </div> */}
                                    </div>
                                    <div className="slots">{a_ats}</div>
                                  </div>
                                )}
                                {b_ats && (
                                  <div className="studio">
                                    <div className="times-studioName">Studio B</div>
                                    <div className="slots">{b_ats}</div>
                                  </div>
                                )}
                              </>
                            ) : (
                              <Loader />
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="slideStep-buttonCon --date">
                        <SlideButton
                          click={() => {
                            swiper.slidePrev();
                          }}
                          back={true}
                          enabled={true}
                        >
                          Back
                        </SlideButton>
                        <SlideButton
                          click={() => {
                            // console.log("next");
                            swiper.slideNext();
                          }}
                          enabled={timeSlotState}
                          // enabled={}
                        >
                          Payment
                        </SlideButton>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="slideStep-inner">
                    <img
                      src="/imgs/background-gradient.jpg"
                      alt=""
                      className="slideStep-img"
                    />

                    <div className="slideStep-content">
                      <div id="modal-root"></div>
                      <br />
                      <br />

                      <div className="slideStep-buttonCon --small">
                        <SlideButton
                          click={() => {
                            swiper.slidePrev();
                          }}
                          back={true}
                          enabled={true}
                        >
                          Back
                        </SlideButton>
                        <div></div>
                        {/* <SlideButton
                          click={() => {
                            // console.log("next");
                            swiper.slideNext();
                          }}
                          enabled={true}
                        >
                          Next
                        </SlideButton> */}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {paymentConfirmed !== null && (
          <motion.div
            initial={{ opacity: 0, pointerEvents: "none" }}
            animate={{ opacity: 1, pointerEvents: "all" }}
            exit={{ opacity: 0, pointerEvents: "none" }}
            className="confirmed-con"
          >
            <h1 className="email-title --high">
              {/* {paymentConfirmed}  */}
              Your Session
              <br />
              <b> HAS BEEN SCHEDULED.</b>
              <svg
                className="titleImg --small"
                width="372"
                height="294"
                viewBox="0 0 372 294"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M317.924 64.51C321.564 69.6959 321.766 77.1579 318.651 86.4596C315.543 95.7379 309.196 106.639 300.092 118.469C281.89 142.119 252.81 169.294 217.159 194.356C181.508 219.419 146.1 237.578 117.695 246.693C103.487 251.252 91.0861 253.53 81.3102 253.308C71.5096 253.087 64.5637 250.365 60.9234 245.179C57.2831 239.993 57.0806 232.531 60.1961 223.23C63.3037 213.951 69.6506 203.05 78.7554 191.22C96.9573 167.57 126.037 140.396 161.688 115.333C197.339 90.2706 232.747 72.1113 261.152 62.9967C275.36 58.4375 287.761 56.1596 297.537 56.3809C307.337 56.6027 314.283 59.3241 317.924 64.51Z"
                  stroke="#D8E75F"
                  stroke-width="2"
                />
                <path
                  d="M310.798 48.5681C314.439 53.754 314.641 61.216 311.526 70.5177C308.418 79.796 302.071 90.6974 292.967 102.527C274.765 126.177 245.685 153.352 210.034 178.414C174.383 203.477 138.975 221.636 110.57 230.751C96.3615 235.31 83.9611 237.588 74.1852 237.366C64.3846 237.145 57.4387 234.423 53.7984 229.237C50.1581 224.051 49.9556 216.589 53.0711 207.288C56.1787 198.01 62.5256 187.108 71.6304 175.278C89.8323 151.628 118.912 124.454 154.563 99.3912C190.214 74.3287 225.622 56.1694 254.027 47.0548C268.235 42.4956 280.636 40.2177 290.412 40.439C300.212 40.6608 307.158 43.3823 310.798 48.5681Z"
                  stroke="#D8E75F"
                  stroke-width="2"
                />
              </svg>
            </h1>
            {/* <br />
            <br />
            <br />
            <br />
            <br />
            <br /> */}

            {/* <SlideButton
              click={() => {
                paymentConfirmed();
              }}
              enabled={true}
            >
              Add to Calender
            </SlideButton> */}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
